import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  key: {
    id: 'studio.EcglP9',
    defaultMessage: 'Key',
  },
  value: {
    id: 'studio.GufXy5',
    defaultMessage: 'Value',
  },
});
